import React from 'react';
import { useSelector } from 'react-redux';
import FocusTrap from '@s/FocusTrap';
import CheckoutButton from '../../ticket-picker/containers/CheckoutButton';
import { ContinueShoppingButton } from './ContinueShoppingButton';

export const TicketsReservedModal = () => {
  const profileImage = useSelector((state) => state.ui.uiConfig.images.profile_image);
  return (
    <FocusTrap fallback=".tickets-reserved-wrap">
      <div className="tickets-reserved-wrap" aria-modal="true" tabIndex="-1">
        <div className="tickets-reserved__photo">
          <img src={profileImage} />
        </div>
        <div className="tickets-reserved__actions">
          <h1>Your tickets are reserved</h1>
          <div className="tickets-reserved__actions-buttons">
            <CheckoutButton />
            <ContinueShoppingButton buttonClass="" />
          </div>
        </div>
      </div>
    </FocusTrap>
  );
};
